"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logErrorData = exports.logSentryError = exports.logSentryWarning = void 0;
const sentry_browser_1 = __importDefault(require("@snapchat/sentry-browser"));
const logSentryWarning = (message, context) => {
    sentry_browser_1.default.captureMessage(message, buildScopeContext("warning", context));
};
exports.logSentryWarning = logSentryWarning;
// Context can be any type
const logSentryError = (message, context) => {
    sentry_browser_1.default.captureException(new Error(message), buildScopeContext("error", context));
};
exports.logSentryError = logSentryError;
function buildScopeContext(level, context) {
    const scopeContext = { level };
    if (context) {
        scopeContext.contexts = { data: { context } };
    }
    return scopeContext;
}
const logErrorData = (error, feature, options = {}) => {
    sentry_browser_1.default.captureException(error, buildErrorScopeContext("error", options, feature));
};
exports.logErrorData = logErrorData;
function buildErrorScopeContext(level, options, feature = "unknown") {
    const scopeContext = { level };
    if (options.context) {
        scopeContext.contexts = {
            data: options.context,
        };
    }
    scopeContext.tags = {
        feature,
    };
    return scopeContext;
}
//# sourceMappingURL=logging.js.map